import { render, staticRenderFns } from "./type-strategy-authority.vue?vue&type=template&id=2ce2c645&"
import script from "./type-strategy-authority.vue?vue&type=script&lang=js&"
export * from "./type-strategy-authority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports